import { Component, OnInit } from '@angular/core';
import { ApsPermissionService } from '../../services/aps-permission/aps-permission.service';
import { SystemCountryService } from '../../services/system-country/system-country.service';

@Component({
    selector: 'app-information',
    templateUrl: './information.component.html',
    styleUrls: ['./information.component.scss'],
    standalone: false
})
export class InformationComponent implements OnInit {

  systemCountry: string = '';
  isDownloadingGuide = false;

  constructor(
    private apsPermissionService: ApsPermissionService,
    private systemCountryService: SystemCountryService
  ) {
    this.systemCountryService.setSystemCountry();
  }

  async ngOnInit() {

    this.systemCountry = this.systemCountryService.getSystemCountry();
    await this.apsPermissionService.bootstrapPermissions();
  }

  downloadPdfBra() {

    this.downloadPdf('Brazil_Systemic_Guide.pdf');

  }

  downloadPdfArg() {

    this.downloadPdf('Argentina_Systemic_Guide.pdf');

  }

  private downloadPdf(fileName: string): void {

    if (this.isDownloadingGuide) {
      return;
    }

    this.isDownloadingGuide = true;

    const filePath = `../../../assets/file/${fileName}`;

    fetch(filePath, {
      cache: 'no-store',
    })
      .then(response => {

        if (!response.ok) {
          throw new Error(`Guide download failed with status ${response.status}`);
        }

        return response.blob();
      })
      .then(blob => {

        const urlBlob = URL.createObjectURL(blob);
        const linkDownload = document.createElement('a');
        linkDownload.href = urlBlob;
        linkDownload.download = fileName;
        document.body.appendChild(linkDownload);
        linkDownload.click();
        document.body.removeChild(linkDownload);
        URL.revokeObjectURL(urlBlob);

        window.open(filePath, '_blank');
      })
      .catch((error: unknown) => {

        console.error('[information] error downloading systemic guide', error);
      })
      .finally(() => {

        this.isDownloadingGuide = false;
      });

  }

}
